import type { FormField } from './FormField';
import { reactive, type Reactive } from 'vue';

export type TFormData<T extends Record<string, any>> = {
  [K in keyof T]: FormField<T[K]>;
};

export class Form<T extends Record<string, any>> {
  public formData: Reactive<TFormData<T>>;
  private snapshot?: string;

  constructor(formData: TFormData<T>) {
    this.formData = reactive(formData);
  }

  protected initValidators() {}
  public reset(initState: T | undefined) {}

  public validate() {
    const isValid = (Object.values(this.formData) as Array<FormField<any>>).reduce((acc, field) => {
      field.validate();
      return acc && field.isValid;
    }, true);

    return isValid;
  }

  protected makeSnapshot(dto?: any) {
    this.snapshot = JSON.stringify(dto ?? this.getDTO());
  }

  public getDTO() {
    const obj = {} as T;

    (Object.keys(this.formData) as Array<keyof T>).forEach((key) => {
      obj[key] = (this.formData as any)[key].value;
    });

    return obj;
  }

  public hasChanges() {
    const actualSnapshot = JSON.stringify(this.getDTO());
    return actualSnapshot !== this.snapshot;
  }
}
